import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { AgGridModule } from "@ag-grid-community/angular";

import { MatCardModule } from "@angular/material/card";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { PipesModule } from "src/app/pipes/pipes.module";

import { AutofocusDirective } from "../directives/autofocus.directive";
import { AngularMaterialModule } from "../modules/angular-material/angular-material.module";
import { EditWarehouseComponent } from "../modules/settings/edit-warehouse/edit-warehouse.component";
import { PopupPreviewImageComponent } from "../modules/shared/popup-preview-image/popup-preview-image.component";
import { CreateSellerCentralShipmentsComponent } from "../modules/shipyard/create-seller-central-shipments/create-seller-central-shipments.component";
import { PlanShipmentSkuComponent } from "../modules/shipyard/plan-shipment-sku/plan-shipment-sku.component";
import { SearchAddPlanShipmentSkuComponent } from "../modules/shipyard/search-add-plan-shipment-sku/search-add-plan-shipment-sku.component";
import { ShipmentPlanItemComponent } from "../modules/shipyard/shipment-plan-item/shipment-plan-item.component";
import { SidebarFreemiumDialogComponent } from "../modules/shipyard/sidebar-freemium-dialog/sidebar-freemium-dialog.component";
import { UpgradeFeemiumDialogComponent } from "./../modules/shipyard/upgrade-feemium-dialog/upgrade-feemium-dialog.component";
import { ProductDetailPanelComponent } from "../modules/inventory/products/product-detail-panel/product-detail-panel.component";
import { PoFilterDropdownComponent } from "../modules/planyard/purchase-orders/po-filter-dropdown/po-filter-dropdown.component";
import { AddSkuToShipmentComponent } from "../modules/shipyard/shipments-list/add-sku-to-shipment/add-sku-to-shipment.component";
import { PlanShipmentDialogComponent } from "../modules/shipyard/shipments-list/plan-shipment-dialog/plan-shipment-dialog.component";
import { SidebarActionComponentComponent } from "../modules/logistic/custome-component/custome-right-sidebar/sidebar-action-component/sidebar-action-component.component";

import { AccountDetailPopupComponent } from "./account-detail-popup/account-detail-popup.component";
import { ActionDetailButtonComponent } from "./action-detail-button/action-detail-button.component";
import { ActionsComponent } from "./actions/actions.component";
import { AddOtherAddressComponent } from "./add-other-address/add-other-address.component";
import { BulkDialogComponent } from "./bulk-dialog/bulk-dialog.component";
import { ButtonComponent } from "./button/button.component";
import { ChannalIconComponent } from "./channal-icon/channal-icon.component";
import { ColumnDropdownComponent } from "./column-dropdown/column-dropdown.component";
import { CommonSidebarComponent } from "./common-sidebar/common-sidebar.component";
import { CreateSeasonDialogComponent } from "./create-season-dialog/create-season-dialog.component";
import { CustomDateHeaderComponent } from "./custom-header/customDateHeader";
import { DatePickerDialogComponent } from "./date-picker-dialog/date-picker-dialog.component";
import { DragIndicatorComponent } from "./drag-indicator/drag-indicator.component";
import { FeatureExplenationComponent } from "./feature-explenation/feature-explenation.component";
import { FilterDropdownComponent } from "./filter-dropdown/filter-dropdown.component";
import { HeaderComponent } from "./header/header.component";
import { HorizontalTabsComponent } from "./horizontal-tabs/horizontal-tabs.component";
import { ItemTypeaheadComponent } from "./item-typeahead/item-typeahead.component";
import { LogoComponent } from "./logo/logo.component";
import { MarketplaceConnectionsComponent } from "./marketplace-connections/marketplace-connections.component";
import { NoResultsComponent } from "./no-results/no-results.component";
import { NumericCellEditorComponent } from "./numeric-cell-editor/numeric-cell-editor.component";
import { PageContainerComponent } from "./page-container/page-container.component";
import { PlanShipmentHeaderComponent } from "./plan-shipment-header/plan-shipment-header.component";
import { PopupCreatePalletsComponent } from "./popup-create-pallets/popup-create-pallets.component";
import { ProductsComponent } from "./products/billing.component";
import { QuickFiltersComponent } from "./quick-filters/quick-filters.component";
import { RestockTagsComponent } from "./restock-tags/restock-tags.component";
import { SelectVendorItemComponent } from "./select-item/select-item.component";
import { SelectVendorOptionsComponent } from "./select-vendor-options/select-vendor-options.component";
import { ShipmentInfoBarComponent } from "./shipment-info-bar/shipment-info-bar.component";
import { ShipmentSkuComponent } from "./shipment-sku/shipment-sku.component";
import { ShipmentVelocityComponent } from "./shipment-velocity/shipment-velocity.component";
import { SkuChipComponent } from "./sku-chip/sku-chip.component";
import { TabsComponent } from "./tabs/tabs.component";
import { ToggleFbmComponent } from "./toggle-fbm/toggle-fbm.component";
import { VerticalTabsComponent } from "./vertical-tabs/vertical-tabs.component";
import { BulkDialogGridComponent } from "./bulk-dialog/bulk-dialog-grid/bulk-dialog-grid.component";
import { BulkDialogUploadComponent } from "./bulk-dialog/bulk-dialog-upload/bulk-dialog-upload.component";
import { AddItemDialogComponent } from "./dialogs/add-item-dialog/add-item-dialog.component";
import { AddSkuDialogComponent } from "./dialogs/add-sku-dialog/add-sku-dialog.component";
import { ConfirmDialogComponent } from "./dialogs/confirm-dialog/confirm-dialog.component";
import { CreateVendorItemComponent } from "./dialogs/create-vendor-item/create-vendor-item.component";
import { DialogFooterComponent } from "./dialogs/dialog-footer/dialog-footer.component";
import { DialogHeaderComponent } from "./dialogs/dialog-header/dialog-header.component";
import { DialogComponent } from "./dialogs/dialog/dialog.component";
import { ErrorDialogComponent } from "./dialogs/error-dialog/error-dialog.component";
import { FeedbackDialogComponent } from "./dialogs/feedback-dialog/feedback-dialog.component";
import { MapSkuToProductComponent } from "./dialogs/map-sku-to-product/map-sku-to-product.component";
import { PaymentDialogComponent } from "./dialogs/payment-dialog/payment-dialog.component";
import { ProcessesDialogComponent } from "./header/processes-dialog/processes-dialog.component";
import { UpdatesDialogComponent } from "./header/updates-dialog/updates-dialog.component";
import { InputSwitcherComponent } from "./inputs/input-switcher/input-switcher.component";
import { RepriceModelInputComponent } from "./inputs/reprice-model-input/reprice-model-input.component";
import { AmazonNewConnectionComponent } from "./marketplace-connections/amazon-new-connection/amazon-new-connection.component";
import { NewConnectionComponent } from "./marketplace-connections/new-connection/new-connection.component";
import { WalmartNewConnectionComponent } from "./marketplace-connections/walmart-new-connection/walmart-new-connection.component";
import { PageContainerButtonGroupComponent } from "./page-container/page-container-button-group/page-container-button-group.component";
import { PageContainerDeviderComponent } from "./page-container/page-container-devider/page-container-devider.component";
import { PageContainerGroupComponent } from "./page-container/page-container-group/page-container-group.component";
import { ProductCardComponent } from "./products/product-card/product-card.component";
import { SkuDateComponent } from "./shipment-sku/sku-date/sku-date.component";
import { ProductDashboardComponent } from "./product-dashboard/product-dashboard.component";
import { RangeDatepickerComponent } from "../modules/dashboard/range-datepicker/range-datepicker.component";
import { ShipmentCollectionGraphComponent } from "../modules/dashboard/shipment-collection-graph/shipment-collection-graph.component";
import { PageContainerHeaderComponent } from './page-container/page-container-header/page-container-header.component';
import { SummaryCardComponent } from "./summary-card/summary-card.component";
import { SummaryContainerComponent } from "./summary-container/summary-container.component";
import { AnalyticsColumnDropdownComponent } from './analytics-column-dropdown/analytics-column-dropdown.component';
import { CompanyListItemComponent } from "./company-list-item/company-list-item.component";
import { ThirdPlMarketplaceConnectionComponent } from "./marketplace-connections/third-pl-marketplace-connection/third-pl-marketplace-connection.component";
import { ShowCompanyDetailsPopupComponent } from "./dialogs/show-company-details-popup/show-company-details-popup.component";
import { ChangeShipWarehouseAddressComponent } from './change-ship-warehouse-address/change-ship-warehouse-address.component';
import { DateComponentRendererComponent } from "./date-component-renderer/date-component-renderer.component";
import { SnackbarComponent } from "./snackbar/snackbar.component";
import { DuplicateSkuComponent } from './duplicate-sku/duplicate-sku.component';
import { FbmOrderProductDialogComponent } from "./fbm-order-product-dialog/fbm-order-product-dialog.component";
import { FbmOrderPoductInfoComponent } from "./fbm-order-product-dialog/fbm-order-poduct-info/fbm-order-poduct-info.component";
import { ShipStationConnectionComponent } from './marketplace-connections/ship-station-connection/ship-station-connection.component';
import { ShipstationNewConnectionComponent } from './marketplace-connections/ship-station-connection/shipstation-new-connection/shipstation-new-connection.component';
import { ShipstationConnectionDetailsComponent } from './marketplace-connections/ship-station-connection/shipstation-connection-details/shipstation-connection-details.component';
import { MatTableModule } from "@angular/material/table";
import { PlanPreviewComponent } from "./plan-preview/plan-preview.component";
import { SkuViewComponent } from "./sku-view/sku-view.component";
import { RenderListItemComponent } from "./render-list-item/render-list-item.component";
import { SettlementGroupComponent } from "./settlement-group/settlement-group.component";
import { CreateGroupComponent } from "./create-group/create-group.component";
import { UnmappedSkusComponent } from "./unmapped-skus/unmapped-skus.component";
import { QuickMappingPopupComponent } from "./quick-mapping-popup/quick-mapping-popup.component";
import { CreateProductDialogComponent } from "./create-product-dialog/create-product-dialog.component";
import { SelectAllButtonComponent } from "./select-all-button/select-all-button.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { SettingFeedbackDailogComponent } from './dialogs/setting-feedback-dailog/setting-feedback-dailog.component';
import { EditMappingComponent } from './dialogs/edit-mapping/edit-mapping.component';
import { VendorSettingsComponent } from './vendor-settings/vendor-settings.component';
import { PlanAddedComponent } from './plan-added/plan-added.component';
import { CreateItemComponent } from './dialogs/create-item/create-item.component';
import { UpdateRepricerComponent } from "./dialogs/update-repricer/update-repricer.component";
import { NumberFormatorDirectiveModule } from "../directives/number-format.directive";
import { CommonDropdownComponent } from './dialogs/common-dropdown/common-dropdown.component';
import { KpisGraphComponent } from "../modules/analytics/kpis-graph/kpis-graph.component";
import { SalesTrendsGraphComponent } from "../modules/analytics/sales-trends-graph/sales-trends-graph.component";
import { PublishListingComponent } from './publish-listing/publish-listing.component';
import { NotePopupComponent } from './note-popup/note-popup.component';
import { CreateShipmentPopupComponent } from './create-shipment-popup/create-shipment-popup.component';
import { RelatedShipmentPopupComponent } from "../modules/shipyard/related-shipment-popup/related-shipment-popup.component";
import { DateDialogComponent } from './date-dialog/date-dialog.component';
import { OpenCaseTemplateComponent } from './dialogs/open-case-template/open-case-template.component';
import { RefundAmountComponent } from './dialogs/refund-amount/refund-amount.component';
import { MultipleOpenCaseDialogComponent } from './dialogs/multiple-open-case-dialog/multiple-open-case-dialog.component';

import { BarChartComponent } from "./charts/bar-chart/bar-chart.component";
import { CircularProgressComponent } from "./charts/circular-progress/circular-progress.component";
import { DoughnutChartComponent } from "./charts/doughnut-chart/doughnut-chart.component";
import { LineChartComponent } from "./charts/line-chart/line-chart.component";

import { SkuGenerateDialogComponent } from './sku-generate-dialog/sku-generate-dialog.component';
import { CreateNewTemplateComponent } from './dialogs/create-new-template/create-new-template.component';

import { KpisSalesGraphComponent } from "../modules/analytics/kpis-sales-graph/kpis-sales-graph.component";

import { CreateShipmentConfirmDialogComponent } from "./create-shipment-confirm-dialog/create-shipment-confirm-dialog.component";
import { KpiDashboardComponent } from "../modules/analytics/kpi-dashboard/kpi-dashboard.component";
import { AssignTagsComponent } from "./assign-tags/assign-tags.component";
import { RemoveTagsComponent } from "./remove-tags/remove-tags.component";
import { MappedItemPopupComponent } from './mapped-item-popup/mapped-item-popup.component';
import { DeductViaSkuDialogComponent } from "./deduct-via-sku-dialog/deduct-via-sku-dialog.component";
import { PublishListingWalmartComponent } from "./publish-listing-walmart/publish-listing-walmart.component";
import { ShippingDialogComponent } from "./shipping-dialog/shipping-dialog.component";
import { CreateQuickProductDialogComponent } from './dialogs/create-quick-product-dialog/create-quick-product-dialog.component';



@NgModule({
  declarations: [
    PageContainerComponent,
    PageContainerDeviderComponent,
    PageContainerGroupComponent,
    ButtonComponent,
    RepriceModelInputComponent,
    InputSwitcherComponent,
    DialogComponent,
    ErrorDialogComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    HeaderComponent,
    PageContainerButtonGroupComponent,
    UpdatesDialogComponent,
    ChannalIconComponent,
    FeatureExplenationComponent,
    MarketplaceConnectionsComponent,
    WalmartNewConnectionComponent,
    AmazonNewConnectionComponent,
    DragIndicatorComponent,
    ConfirmDialogComponent,
    NoResultsComponent,
    ProcessesDialogComponent,
    FilterDropdownComponent,
    FeedbackDialogComponent,
    SkuChipComponent,
    AutofocusDirective,
    ProductsComponent,
    ProductDetailPanelComponent,
    ProductCardComponent,
    PaymentDialogComponent,
    CommonSidebarComponent,
    LogoComponent,
    ItemTypeaheadComponent,
    ColumnDropdownComponent,
    NumericCellEditorComponent,
    AddSkuDialogComponent,
    AddItemDialogComponent,
    ShipmentSkuComponent,
    TabsComponent,
    PlanShipmentDialogComponent,
    CreateSellerCentralShipmentsComponent,
    PlanShipmentSkuComponent,
    ShipmentPlanItemComponent,
    PopupPreviewImageComponent,
    AddSkuToShipmentComponent,
    SearchAddPlanShipmentSkuComponent,
    VerticalTabsComponent,
    HorizontalTabsComponent,
    ActionsComponent,
    SidebarActionComponentComponent,
    ActionDetailButtonComponent,
    EditWarehouseComponent,
    PopupCreatePalletsComponent,
    ShipmentVelocityComponent,
    QuickFiltersComponent,
    SelectVendorOptionsComponent,
    BulkDialogComponent,
    BulkDialogGridComponent,
    BulkDialogUploadComponent,
    PoFilterDropdownComponent,
    MapSkuToProductComponent,
    CreateVendorItemComponent,
    AddOtherAddressComponent,
    AccountDetailPopupComponent,
    SelectVendorItemComponent,
    UpgradeFeemiumDialogComponent,
    SidebarFreemiumDialogComponent,
    SkuDateComponent,
    PlanShipmentHeaderComponent,
    PlanPreviewComponent,
    SkuViewComponent,
    RestockTagsComponent,
    CreateSeasonDialogComponent,
    DatePickerDialogComponent,
    SnackbarComponent,
    NewConnectionComponent,
    CustomDateHeaderComponent,
    CompanyListItemComponent,
    ShowCompanyDetailsPopupComponent,
    ThirdPlMarketplaceConnectionComponent,
    ProductDashboardComponent,
    RangeDatepickerComponent,
    ShipmentCollectionGraphComponent,
    ShipmentInfoBarComponent,
    ToggleFbmComponent,
    SummaryCardComponent,
    SummaryContainerComponent,
    RenderListItemComponent,
    AnalyticsColumnDropdownComponent,
    ChangeShipWarehouseAddressComponent,
    DateComponentRendererComponent,
    PageContainerHeaderComponent,
    DuplicateSkuComponent,
    SummaryContainerComponent,
    FbmOrderProductDialogComponent,
    FbmOrderPoductInfoComponent,
    ShipStationConnectionComponent,
    ShipstationNewConnectionComponent,
    ShipstationConnectionDetailsComponent,
    SettlementGroupComponent,
    CreateGroupComponent,
    UnmappedSkusComponent,
    QuickMappingPopupComponent,
    CreateProductDialogComponent,
    SelectAllButtonComponent,
    SettingFeedbackDailogComponent,
    EditMappingComponent,
    VendorSettingsComponent,
    PlanAddedComponent,
    CreateItemComponent,
    UpdateRepricerComponent,
    CommonDropdownComponent,
    KpisGraphComponent,
    SalesTrendsGraphComponent,
    PublishListingComponent,
    PublishListingWalmartComponent,
    NotePopupComponent,
    CreateShipmentPopupComponent,
    RelatedShipmentPopupComponent,
    BarChartComponent,
    CircularProgressComponent,
    DoughnutChartComponent,
    LineChartComponent,
    DateDialogComponent,
    OpenCaseTemplateComponent,
    RefundAmountComponent,
    MultipleOpenCaseDialogComponent,
    SkuGenerateDialogComponent,
    CreateNewTemplateComponent,
    KpisSalesGraphComponent,
    CreateShipmentConfirmDialogComponent,
    KpiDashboardComponent,
    AssignTagsComponent,
    RemoveTagsComponent,
    MappedItemPopupComponent,
    DeductViaSkuDialogComponent,
    ShippingDialogComponent,
    CreateQuickProductDialogComponent,
    DeductViaSkuDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AngularMaterialModule,
    RouterModule,
    AgGridModule,
    PipesModule,
    MatProgressBarModule,
    MatCardModule,
    NumberFormatorDirectiveModule,
    MatTableModule,
    InfiniteScrollModule
  ],
  exports: [
    PageContainerComponent,
    PageContainerDeviderComponent,
    PageContainerGroupComponent,
    ButtonComponent,
    RepriceModelInputComponent,
    DialogComponent,
    ErrorDialogComponent,
    HeaderComponent,
    PageContainerButtonGroupComponent,
    ChannalIconComponent,
    FeatureExplenationComponent,
    MarketplaceConnectionsComponent,
    WalmartNewConnectionComponent,
    AmazonNewConnectionComponent,
    DragIndicatorComponent,
    NoResultsComponent,
    InputSwitcherComponent,
    SkuChipComponent,
    AutofocusDirective,
    ProductsComponent,
    ProductDetailPanelComponent,
    ProductCardComponent,
    PaymentDialogComponent,
    CommonSidebarComponent,
    LogoComponent,
    ItemTypeaheadComponent,
    ColumnDropdownComponent,
    AddSkuDialogComponent,
    AddItemDialogComponent,
    ShipmentSkuComponent,
    TabsComponent,
    PlanShipmentDialogComponent,
    CreateSellerCentralShipmentsComponent,
    PlanShipmentSkuComponent,
    ShipmentPlanItemComponent,
    PopupPreviewImageComponent,
    AddSkuToShipmentComponent,
    VerticalTabsComponent,
    HorizontalTabsComponent,
    ActionsComponent,
    SidebarActionComponentComponent,
    ActionDetailButtonComponent,
    EditWarehouseComponent,
    PopupCreatePalletsComponent,
    ShipmentVelocityComponent,
    QuickFiltersComponent,
    SelectVendorOptionsComponent,
    BulkDialogComponent,
    BulkDialogGridComponent,
    BulkDialogUploadComponent,
    PoFilterDropdownComponent,
    SearchAddPlanShipmentSkuComponent,
    AddOtherAddressComponent,
    SelectVendorItemComponent,
    UpgradeFeemiumDialogComponent,
    SidebarFreemiumDialogComponent,
    PlanShipmentHeaderComponent,
    PlanPreviewComponent,
    SkuViewComponent,
    RestockTagsComponent,
    CreateSeasonDialogComponent,
    CustomDateHeaderComponent,
    DatePickerDialogComponent,
    SnackbarComponent,
    CompanyListItemComponent,
    ThirdPlMarketplaceConnectionComponent,
    ShipmentInfoBarComponent,
    ProductDashboardComponent,
    RangeDatepickerComponent,
    ShipmentCollectionGraphComponent,
    ShipmentInfoBarComponent,
    NewConnectionComponent,
    SummaryCardComponent,
    SummaryContainerComponent,
    RenderListItemComponent,
    DateComponentRendererComponent,
    PageContainerHeaderComponent,
    SkuDateComponent,
    FbmOrderProductDialogComponent,
    FbmOrderPoductInfoComponent,
    ShipStationConnectionComponent,
    SettingFeedbackDailogComponent,
    VendorSettingsComponent,
    PlanAddedComponent,
    CommonDropdownComponent,
    SettlementGroupComponent,
    KpisGraphComponent,
    SalesTrendsGraphComponent,
    RelatedShipmentPopupComponent,
    OpenCaseTemplateComponent,
    BarChartComponent,
    CircularProgressComponent,
    DoughnutChartComponent,
    LineChartComponent,
    KpisSalesGraphComponent,
    CreateShipmentConfirmDialogComponent,
    KpiDashboardComponent,
    RemoveTagsComponent,
    DeductViaSkuDialogComponent,
    ShippingDialogComponent
  ],
})
export class ComponentsModule {}
